export default {"src":"/_next/static/media/plastics.0b959f1f.svg","height":121,"width":121};